import { render } from "./BoxFurtherData.vue?vue&type=template&id=6a4af570"
import script from "./BoxFurtherData.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxFurtherData.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Lfmpublications/Vue/components/BoxFurtherData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a4af570"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a4af570', __exports__)) {
    api.reload('6a4af570', __exports__)
  }
  
  module.hot.accept("./BoxFurtherData.vue?vue&type=template&id=6a4af570", () => {
    api.rerender('6a4af570', render)
  })

}


export default __exports__